import React, {useRef, useContext, Fragment} from "react";
import { connect } from "react-redux";

import LookWizardContentButtons from "./lookWizardContentButtons";
import LookWizardContentCanvas from "./lookWizardContentCanvas";
import LookWizardCompletedAlertModal from "./lookWizardCompletedAlertModal";
import LookWizardContentTitle from "./lookWizardContentTitle";
import LookWizardContentDescription from "./lookWizardContentDescription";
// import LookWizardContentMatch from "./lookWizardContentMatch";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import LookWizardContext from "./lookWizardContext";
import LookWizardContentFeature from "./lookWizardContentFeature";
import LookWizardContentCustomGroup from "./lookWizardContentCustomGroup";


const LookWizardContent = (props) => {

  const {wizardActiveStep, isMobile, imageCanvas} = props;
  // const {customImageUrl, uploadedImageUrl} = wizardActiveItem;
  const thumbnailRef = useRef();

  const {isCompletedStep, selectedWizardFeature, selectedWizardCustomGroup} = useContext(LookWizardContext);

  return (
    <div className={"lm-content lw-content p-0" + (!IS_PRODUCT_JOURNEY && wizardActiveStep === -1 ? " lw-content--with-header" : "")}>
      <div className="flex--1 lm-content lw-content">
        <div ref={thumbnailRef} className="right-1 absolute" style={{top: "90px"}}/>
        {selectedWizardFeature
          ? <LookWizardContentFeature/>
          : selectedWizardCustomGroup ? <LookWizardContentCustomGroup/> : (
            <Fragment>
              <div className={"lw-content__thumbnail" + (IS_PRODUCT_JOURNEY ? " lw-content__thumbnail--product" : "")
                + (isCompletedStep ? " lw-content__thumbnail--completed" : "")}
                // style={wizardActiveStep === -1 ? {background: `url(${customImageUrl || uploadedImageUrl}) center / contain no-repeat`,} : null}
              >
                <LookWizardContentCanvas imageCanvas={imageCanvas}/>
                {isMobile ? null : <LookWizardCompletedAlertModal anchorEl={thumbnailRef}/>}
              </div>
              <div className="lw-content__title">
                <LookWizardContentTitle/>
              </div>
              <div className="lw-content__description">
                <LookWizardContentDescription/>
              </div>
            </Fragment>
          )}
      </div>
      <div className="pl-1 pr-1 pb-1">
        <LookWizardContentButtons/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {canvasCount} = store.bathroomVisualizerState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {navigationCount} = store.lookState;

  return {
    wizardActiveStep,
    wizardSelectedValues,
    canvasCount,
    isMobile,
    navigationCount,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

export default connect(mapStateToProps)(LookWizardContent)
